import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';
import { withTranslation } from 'react-i18next';

import SearchBox from '../../Layout/Components/SearchBox';

class ActionsMenu extends React.Component {

  render() {
    const { t, i18n, doSearch, history } = this.props;

    return (
      <Fragment>
        <SearchBox placeholder={t('partners.actions.search')} doSearch={doSearch} />
        <Button className="mb-2 mr-2 btn-icon btn-shadow" size="lg" color="success"
          onClick={() => history.push('/admin/partner')}>
          <i className="lnr-plus-circle btn-icon-wrapper"> </i>
          {t('partners.actions.create')}
        </Button>
      </Fragment>
    );
  }
}

export default withRouter(withTranslation()(ActionsMenu));